import type { ListParams } from "../api";

const PLAIN_KEYS = new Set(["page", "per_page", "sort_by", "sort_order", "sort"]);

export function buildFilterQuery(params?: ListParams): string {
  if (!params) return "";
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === "" || v === null) continue;
    if (PLAIN_KEYS.has(k)) {
      q.set(k, String(v));
    } else {
      q.set(`filter[${k}]`, String(v));
    }
  }
  const s = q.toString();
  return s ? `?${s}` : "";
}

export function buildQuery(params?: ListParams, aliases?: Record<string, string>): string {
  if (!params) return "";
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== "" && v !== null) q.set(aliases?.[k] ?? k, String(v));
  }
  const s = q.toString();
  return s ? `?${s}` : "";
}

export async function get<T>(path: string): Promise<T> {
  const { api } = await import("../api");
  const { data } = await api.get<T>(path);
  return data;
}

export async function post<T>(path: string, body: unknown): Promise<T> {
  const { api } = await import("../api");
  const { data } = await api.post<T>(path, body);
  return data;
}

export async function put<T>(path: string, body: unknown): Promise<T> {
  const { api } = await import("../api");
  const { data } = await api.put<T>(path, body);
  return data;
}

export async function patch<T>(path: string, body: unknown): Promise<T> {
  const { api } = await import("../api");
  const { data } = await api.patch<T>(path, body);
  return data;
}

export async function del(path: string): Promise<void> {
  const { api } = await import("../api");
  await api.delete(path);
}
